export const RecruitmentPlanning = {
    path: '/recruitment_plannings',
    name: 'recruitment_plannings',
    component: () => import('@/views/Recruitment/Planning/PlanningPage.vue'),
    children: [
        {
            path: '/recruitment_plannings/edit/:id',
            name: 'recruitment_plannings.edit',
            component: () => import('@/views/Recruitment/Planning/Form/PlanningForm.vue'),
            props: {updateAction: true},
            children: [
                {
                    path: '/recruitment_plannings/cv_techs/view/:id',
                    name: 'recruitment_plannings.edit.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                },
            ],
        },
        {
            path: '/recruitment_plannings/lock/:id',
            name: 'recruitment_plannings.lock',
            component: () => import('@/views/Recruitment/Planning/Form/PlanningForm.vue'),
            props: {lockAction: true},
            children: [
                {
                    path: '/recruitment_plannings/cv_techs/view/:id',
                    name: 'recruitment_plannings.lock.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                },
            ],
        },
        {
            path: '/recruitment_plannings/delete/:id',
            name: 'recruitment_plannings.delete',
            component: () => import('@/views/Recruitment/Planning/Form/PlanningForm.vue'),
            props: {deleteAction: true},
            children: [
                {
                    path: '/recruitment_plannings/cv_techs/view/:id',
                    name: 'recruitment_plannings.delete.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                },
            ],
        },
        {
            path: '/recruitment_plannings/view/:id',
            name: 'recruitment_plannings.view',
            component: () => import('@/views/Recruitment/Planning/Form/PlanningForm.vue'),
            props: {viewAction: true},
            children: [
                {
                    path: '/recruitment_plannings/cv_techs/view/:id',
                    name: 'recruitment_plannings.view.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                }
            ],
        },

    ],
}